var baseStyle = {
  borderColor: 'gray.300',
  borderStyle: 'solid'
};
var Divider = {
  baseStyle: baseStyle
};
export { Divider as default };